<template>
  <div id="agregar-documento-relacionado">
    <v-file-input
        v-show="false"
        show-size
        label="Seleccionar Archivo PFD"
        type="file"
        ref="anexoDocumento"
        name="anexo"
        id="anexo"
        @change="seleccion"
      >
    </v-file-input>
    <v-form ref="agregarDocumentoRelacionado" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Archivo Relacionado
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
            v-model="documentoRelacionado.descripcion"
            label="Descripción"
            :rules="[mixReglas.requerido]"
            required>
          </custom-text-field>
          </v-row>
          <v-row v-if="!vistaPrevia">
            <custom-text-area
              v-model="documentoRelacionado.observaciones"
              label="Observaciones"
              required>
            </custom-text-area>
            <v-row align="center">
              <v-col md="4">
                <custom-date-picker
                  v-model="documentoRelacionado.fecha"
                  label="Fecha"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
              </v-col>
              <v-col md="8">
                <custom-button
                  class="mx-4"
                  tipo="formCancelar"
                  :label="rutaArchivo ? 'Cambiar' : 'Seleccionar Archivo'"
                  @click="seleccionarArchivo">
                </custom-button>
                <span v-if="rutaArchivo">
                  {{nombreArchivoSeleccionado}}
                </span>
              </v-col>
            </v-row>
          </v-row>
          <v-row
          v-if="vistaPrevia"
          justify="center">
            <v-col cols="12" md="7" class="grey lighten-3" style="height:400px">
              <!-- si existe una ruta de archivo se carga la vista previa -->
              <template
              v-if="rutaArchivo">
              <VistaPreviaPdf
                :rutaArchivo="this.rutaArchivo" />
              </template>
              <!-- si no existe una ruta de archivo se muestra boton para seleccionar archivo -->
              <template
                v-else>
                  <v-row justify="center" align="center" style="height:100%">
                    <custom-button
                    tipo="agregar"
                    label="Cargar Archivo"
                    iconText="fa-file-pdf"
                    @click="seleccionarArchivo">
                      <v-icon left>
                        fa-file-pdf
                      </v-icon>
                    </custom-button>
                  </v-row>
              </template>
            </v-col>
            <v-col cols="12" md="5">
              <v-row
              v-if="rutaArchivo"
              class="mx-4"
              justify="space-between"
              align="center">
                <span>{{nombreArchivoSeleccionado}}</span>
                <custom-button
                  tipo="formCancelar"
                  label="Cambiar"
                  @click="seleccionarArchivo">
                </custom-button>
              </v-row>
              <custom-text-area
                v-model="documentoRelacionado.observaciones"
                label="Observaciones"
                required>
              </custom-text-area>
              <custom-date-picker
              v-model="documentoRelacionado.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
              </custom-date-picker>
              <template v-if="progreso">
                <v-row class="mx-4 mt-2" justify="center" align="center">
                  <span>Subiendo PDF</span>
                  <v-progress-linear
                    height="25"
                    :value="progreso"
                    color="blue darken-1"
                    dark>
                    <h3>{{ progreso }}</h3>
                  </v-progress-linear>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="guardar"
            :disabled="!esformularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import mixDocumentosRelacionados from './mixDocumentosRelacionados';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'AgregarDocumentoRelacionado',
  mixins: [mixDocumentosRelacionados, mixSubirArchivo],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    moduloOrigen: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
    CustomTextArea,
    CustomDatePicker,
    VistaPreviaPdf,
  },
  data() {
    return {
      vistaPrevia: false,
      esformularioValido: false,
      enviandoFormulario: false,
      nombreArchivoSeleccionado: '',
      progreso: null,
      rutaArchivo: null,
      documentoRelacionado: {
        idReferencia: this.idReferencia,
        publicKey: '', // id publico del documento subido
        extension: '',
        fecha: null,
        descripcion: '',
        observaciones: '',
      },
    };
  },
  methods: {
    async guardar() {
      // si existe una ruta de archivo, se sube el archivo al servidor
      this.enviandoFormulario = true;
      if (this.rutaArchivo) {
        const datosArchivo = this.setDatosArchivo();
        await this.mixSubirArchivo(datosArchivo);
      }
      await this.mixAgregarDocumentoRelacionado();
    },
    setDatosArchivo() {
      let datosArchivo = null;
      if (this.moduloOrigen === 'planeacion') {
        datosArchivo = {
          nombre: `${this.datos.clave} - ${this.documentoRelacionado.descripcion}`,
          path: `Documentos Relacionados/Obras/${this.datos.ejercicio}/${this.datos.clave}`,
        };
      }
      return datosArchivo;
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarDocumentoRelacionado.reset();
    },
  },
  computed: {
  },
  mounted() {
    eventBus.$on('seCargoArchivo', (archivo) => {
      this.documentoRelacionado.publicKey = archivo.data.public_key;
      this.documentoRelacionado.extension = archivo.data.extension;
    });
  },

};
</script>

<style>

</style>
